export default __webpack_public_path__ + "static/media/arabi21.afd70a85.png";